import React from 'react';
import './style.scss';
import PLACED_STUDENTS from '../../dummyData/placed-students.json'
import { PLACEMENTS_CARDS_DATA } from '../../constants';
import { useNavigate } from 'react-router-dom';
import MenuCards from '../../components/sections/MenuCards';

const PlacedStudents = () => {

  const navigate = useNavigate();

  const handleMenuClick = (route) => {
    if (route.includes("http:") || route.includes("https:")) {
      window.open(route, "_blank")
    } else {
      navigate(`/${route}`);
    }
  }

  return (
    <>
      {/* Section: Placed Students */}
      <section className="sh-students">
        <div className="container">
          <div className='text-md-start text-center'>
            <h2 className='global-heading mb-5'>Success Stories</h2>
          </div>
          <div className="sh-students--grid">
            {PLACED_STUDENTS && PLACED_STUDENTS.length > 0 && PLACED_STUDENTS.map((item, index) => (
              <div key={index} className='d-flex flex-column align-items-center d-lg-block'>
                <img className='sh-students--profilepic' src={item?.profilePic} alt='Student Pic' />
                <div className='sh-students--info'>
                  <p className='sh-students--info--text--name d-flex justify-content-between align-items-center'>
                    <span>{item?.name}</span>
                  </p>
                  <div className='sh-students--info--divider'></div>
                  <p className='sh-students--info--text'>From: {item?.district}, {item?.state}</p>
                  <div className='sh-students--info--divider'></div>
                  <p className='sh-students--info--text'>
                    Working at: {item?.companyLogo && item?.companyUrl ? (
                      <a href={item.companyUrl} target="_blank" rel="noopener noreferrer">
                        <img src={item.companyLogo} alt="Logo" style={{ width: '85px', height: '25px', marginLeft: '3px' }} />
                      </a>
                    ) : item?.companyLogo ? (
                      <img src={item.companyLogo} alt="Logo" style={{ width: '85px', height: '25px', marginLeft: '3px' }} />
                    ) : null}
                  </p>

                  <div className='sh-students--info--divider'></div>
                  <p className='sh-students--info--text'>Increase in Family Income: <span className='sh-students--info--text--increment'>{item?.incrementBy}</span></p>
                </div>

              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section:Menu Cards */}
      <section className="container py-lg-5 mb-5">
        <MenuCards
          data={PLACEMENTS_CARDS_DATA}
          handleMenuClick={handleMenuClick}
        />
      </section>
    </>
  )
}

export default PlacedStudents;
